import React from 'react';

import { Flex, Select, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { IsoCountryCode } from 'shared/interfaces/Country';
import { PhoneNumberProvider } from 'shared/interfaces/Telephony';

export interface PhoneNumberSearchBarFormProps {
  countryCode: IsoCountryCode;
  searchQuery: string;
  provider: PhoneNumberProvider;
}

interface PhoneNumberSearchBarProps {
  searchForm: UseFormReturnType<PhoneNumberSearchBarFormProps>;
}

export function PhoneNumberSearchBar(phoneNumberSearchBarProps: PhoneNumberSearchBarProps) {
  const { searchForm } = phoneNumberSearchBarProps;
  const { t } = useTranslation();

  return (
    <Flex align="center" mb="sm" gap="md">
      <TextInput
        icon={<IconSearch size={16} />}
        placeholder={t('SMART_ASSISTANT.TELEPHONY_SECTION.PURCHASE_MODAL.SEARCH_PLACEHOLDER')}
        {...searchForm.getInputProps('searchQuery')}
        maxLength={10}
        style={{ flexGrow: 1 }}
      />
      <Select
        {...searchForm.getInputProps('countryCode')}
        maw={200}
        data={[
          { value: 'US', label: t('SMART_ASSISTANT.TELEPHONY_SECTION.PURCHASE_MODAL.COUNTRY_SELECT.US') },
          { value: 'CA', label: t('SMART_ASSISTANT.TELEPHONY_SECTION.PURCHASE_MODAL.COUNTRY_SELECT.CA') }
        ]}
        style={{ flexGrow: 1 }}
      />
    </Flex>
  );
}
